import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import fullscreen from 'assets/fullscreen_button.svg';
import fullscreenExit from 'assets/fullscreen_exit_button.svg';
import './style.scss';
import ThemeContext from '../../../../ThemeContext';
import closeButton from 'assets/close.svg';
import toggleChatsizeButtonLarger from 'assets/maximize.svg';
import toggleChatsizeButtonSmaller from 'assets/minimize.svg';
import logoImage from 'assets/avatar.svg';

const Header = ({
    title,
    subtitle,
    fullScreenMode,
    toggleFullScreen,
    toggleChat,
    toggleChatsize,
    largeChatsizeEnabled,
    showCloseButton,
    showFullScreenButton,
    connected,
    connectingText,
    closeImage,
}) => {
    const { mainColor, headerLogo } = useContext(ThemeContext);

    const avatarClassName = ['rw-avatar'];
    if (headerLogo?.shape === 'wide') {
        avatarClassName.push('rw-avatar-wide');
    } else {
        avatarClassName.push('rw-avatar-rect-aa');
    }
    if (headerLogo?.invert) {
        avatarClassName.push('rw-avatar-invert');
    }
    // Optical alignment: shift the logo so a wordmark's baseline sits on the
    // title baseline instead of its bounding box being centred (see
    // ThemeContext headerLogo.offsetY).
    const avatarStyle = headerLogo?.offsetY
        ? { position: 'relative', top: `${headerLogo.offsetY}px` }
        : undefined;

    return (
        <div className="rw-header-and-loading">
            <div style={{ backgroundColor: mainColor }} className="rw-header">
                <img
                    src={headerLogo?.src ?? logoImage}
                    className={avatarClassName.join(' ')}
                    style={avatarStyle}
                    alt={headerLogo?.alt ?? 'chat avatar'}
                />
                <div className="rw-header-text-container">
                    <h4 className="rw-title">{title}</h4>
                    {subtitle && <span className="rw-subtitle">{subtitle}</span>}
                </div>
                <div className="rw-header-buttons">
                    {showFullScreenButton && (
                        <button
                            className="rw-header-button rw-toggle-fullscreen-button"
                            onClick={toggleFullScreen}
                        >
                            <img
                                className={`rw-toggle-fullscreen ${fullScreenMode ? 'rw-fullScreenExitImage' : 'rw-fullScreenImage'}`}
                                src={fullScreenMode ? fullscreenExit : fullscreen}
                                alt="toggle fullscreen"
                            />
                        </button>
                    )}
                    {toggleChatsize && (
                        <button
                            className="rw-header-button rw-nomobile rw-toggle-chatsize-button"
                            onClick={toggleChatsize}
                        >
                            <img
                                className="rw-toggle-chatsize"
                                src={
                                    largeChatsizeEnabled
                                        ? toggleChatsizeButtonSmaller
                                        : toggleChatsizeButtonLarger
                                }
                                alt="toggle chatsize"
                            />
                        </button>
                    )}
                    {showCloseButton && (
                        <button className="rw-header-button rw-close-button" onClick={toggleChat}>
                            <img
                                className={`rw-close ${closeImage ? '' : 'rw-default'}`}
                                src={closeImage || closeButton}
                                alt="close"
                            />
                        </button>
                    )}
                </div>
            </div>
            {!connected && <span className="rw-loading">{connectingText}</span>}
        </div>
    );
};

Header.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    fullScreenMode: PropTypes.bool,
    toggleFullScreen: PropTypes.func,
    toggleChat: PropTypes.func,
    toggleChatsize: PropTypes.func,
    largeChatsizeEnabled: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    showFullScreenButton: PropTypes.bool,
    connected: PropTypes.bool,
    connectingText: PropTypes.string,
    closeImage: PropTypes.string,
};

export default Header;
